import { render, staticRenderFns } from "./PopularProfessionsSection.vue?vue&type=template&id=59f0a5d4&scoped=true"
import script from "./PopularProfessionsSection.vue?vue&type=script&lang=js"
export * from "./PopularProfessionsSection.vue?vue&type=script&lang=js"
import style0 from "./PopularProfessionsSection.vue?vue&type=style&index=0&id=59f0a5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f0a5d4",
  null
  
)

export default component.exports